module.exports = __webpack_public_path__ + "static/Sebastian-Jimenez-bff9300d9046218f3427659d2bf7ec38.png";